import Vue, { ref } from 'vue'
import { defineStore } from 'pinia'
import { ConfigurationModuleAdapter } from '../Components/ConfigurationManager/adapter/ConfigurationModuleAdapter'
import { ConfigModule } from '../Components/ConfigurationManager/type/ConfigModule'
import { Observable } from 'rxjs'
import { JsonApiResponseAdapter, Nullable, RawApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { ClvrGroupId } from '../Type/GroupId'
import {
    ConfigurationListEntryAdapter
} from "../Components/ConfigurationManager/adapter/ConfigurationListEntryAdapter";

export const ALL_ESTABLISHMENT_ID = null

export const useConfigStore = defineStore('config', () => {
    const loading = ref<boolean>(false)
    const currentEstablishment = ref<Nullable<number>>(ALL_ESTABLISHMENT_ID)
    const modulesConfig = ref<ConfigModule[]>([])

    const loadModuleConfig = (
        groupId: ClvrGroupId,
        moduleName: string,
    ): Observable<JsonApiResponseAdapter<ConfigModule>> => {
        loading.value = true

        const apiCall = Vue.$http.get(`api/v1/system/config/module/${moduleName}`, new ConfigurationModuleAdapter(), {
            group_id: groupId,
        })

        apiCall.subscribe(result => {
            const moduleIndex = modulesConfig.value.findIndex(
                module => module.key === moduleName && module.group === groupId,
            )
            const configModule = result.getOneData()

            if (moduleIndex < 0 && configModule) {
                modulesConfig.value = [...modulesConfig.value, configModule]
            } else {
                //replace object without mutation
                modulesConfig.value = Object.assign([], modulesConfig.value, {
                    [moduleIndex]: result.getOneData(),
                })
            }
            loading.value = false
        })

        return apiCall
    }

    const saveModuleConfig = (
        groupId: ClvrGroupId,
        moduleName: string,
        configData: Record<string, unknown>,
    ): Observable<JsonApiResponseAdapter<ConfigModule>> => {
        return Vue.$http.post(
            `api/v1/system/config/module/${moduleName}`,
            new ConfigurationModuleAdapter(),
            configData,
            {
                params: {
                    group_id: groupId,
                },
            },
        )
    }

    const checkConfigListValueInUse = (module: string, configKey: string, value: unknown) => {
        return Vue.$http.get(`api/v1/${module}/${configKey}`, new RawApiDataAdapter(), {
            value: value,
        })
    }

    const loadItemListConfiguration = (listKeyName: string, groupId: ClvrGroupId, className: string) =>
        Vue.$http.get(`api/v1/system/configuration-datalist/${listKeyName}`,  new ConfigurationListEntryAdapter(), {
            className: className,
            groupId: groupId,
        })

    return {
        loading,
        currentEstablishment,
        modulesConfig,
        loadModuleConfig,
        saveModuleConfig,
        checkConfigListValueInUse,
        loadItemListConfiguration,
    }
})
